import { StyledMiniPhone } from './PhoneField.styles';

export const EmptyComponent = () => null;

export const InternationalIcon = () => <StyledMiniPhone width={18} height={18} />;
